<template>
  <div>
    <!--<simple-click-event title="title1" @clickNow="clickNow">
      <h1>eewewew</h1>
    </simple-click-event>-->
    <!--<simple-click-event title="title2"></simple-click-event>-->
    <inner-click-component>
      <h2>{{paramTitle}}：哈哈哈{{paramCount}} </h2>
    </inner-click-component>
    <inner-click-component @click=""></inner-click-component>
  </div>
</template>

<script>
  export default {
    name: "SimpleClickEvent",
    props:{
      paramTitle:{
        type: String,
        default:"初始标题"
      },
      paramCount:{
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        paramCount:2
      }
    },
    //template:"<div><h2>hhhhhh</h2><button v-on:click='clickFun'>{{title}} you can click me {{count}} times.</button><slot></slot></div>",
    methods:{
      clickFun:function () {
        this.count++;
        this.$emit('clickNow', this.count);
      },
      clickNow:function (e) {
        console.log(e);
      }
    },
    components:{
      innerClickComponent:{
        data: function(){
          return{
            //todo 这个外部怎么 传值进来
            title: "同学",
            count: 0
          }
        },
        template:"<div><h2>hhhhhh</h2><button v-on:click='clickFun'>{{title}} you can click me {{count}} times.</button><slot></slot></div>",
        methods:{
          clickFun:function () {
            this.count++;
            this.$emit('clickNow', this.count);
          },
          clickNow:function (e) {
            console.log(e);
          },
          setDate(title, count) {
            this.title = title;
            this.count = count;
            //this.$emit('', this.title, this.count);
          }
        },
      }
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/SimpleClickEvent.vue